module.exports = __webpack_public_path__ + "img/metal_t@2x.5b7dacf1.png";